import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SalesReturnService {


  constructor(private http: HttpClient) { }
  url = environment.serverAPI5 + '/' + 'api/salesreturn';

  url1 = environment.serverAPI1 + "/api";

  url2 = environment.serverAPI5 + '/' + 'api';

  searchSalesReturn(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  getSalesReturn(Page: number, size: number, sort: number): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }
  getAllSalesReturnDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }

  getSalesReturnById(salesReturnId: number): Observable<Object> {
    return this.http.get(`${this.url}/${salesReturnId}`);
  }
  createSalesReturn(Salesreturn: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, Salesreturn);
  }

  deleteImage(data: any): Observable<Object> {
    return this.http.post(`${this.url}/deleteImage`, data);
  }
  downloadSalesReturnReport(Page: number, size: number, sort, selectionSales): Observable<any> {
    return this.http.post(`${this.url}/export/page?page=${Page}
		&size=${size}&sort=${sort}`, selectionSales, {
      responseType: 'arraybuffer',
      observe: 'response'
    });
  }
  downloadSalesReturnTemplate(): Observable<any> {
    return this.http.get(`${this.url}/template/download`, { responseType: 'arraybuffer', observe: 'response' });
  }
  deleteBySalesReturnId(salesOrderId: any): Observable<Object> {
    return this.http.delete(`${this.url}/${salesOrderId}`);
  }

}
